import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { variables } from './Variables.js';
import MainArticle_Ar from './MainArticle_Ar.js';
import SmallArticle_Ar from './SmallArticle_Ar.js';
export default function ListMainArticle_Ar() {
  const jsonUrl = variables.basename_url + 'updates/index/Coinsinsight_HomeAr_TrendingNews.json';
  const [isLoading, setNisLoading] = useState(false);
  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    Get_Data();
  }
  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data() {
    JsonArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        for (let i = 0; i <= 3 && i < response.data.length; i++) {
          JsonArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date,
            news_imagename: response.data[i].image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),

            Category: response.data[i].Category,
          })
        }
      })
  }
  useEffect(() => {
    setNisLoading(true);
    refda();
  }, [])
  return (
    <>
      <section className="post-news-2-area">
        <div className="container custom-container">
          <div className="row ">
            <div className="col-lg-6  ">
              <div className="post_gallery_play post_gallery_play-2 mt-40">
                {/* Main Article Here  */}
                <MainArticle_Ar />
              </div>
            </div>


            <div className="col-lg-3 col-md-5">
              <div className="post-news-list mt-40" >

                {JsonArray.map(da =>
                  <div key={da.news_title}  >
                    <div className="post-gallery-style-2 most-view-style-2">
                      <div className="post-gallery-thumb" >
                        <a href={da.link}>
                          <img style={{ maxWidth: '100%', maxHeight: '57px', minHeight: '57px' }} className='rounded' src={da.news_imagename} alt="gallery" />
                        </a>
                      </div>

                      <div className="post-gallery-content">
                        <h5 className="title Arabic-text"><a href={da.link} tabIndex={-1}>{da.news_title}</a></h5>
                        <div className="meta-post-2-style" >
                          <div className="meta-post-categores">
                            <a href="#" tabIndex={-1}>{da.Category}</a>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                    <div></div>
                  </div>
                )}

              </div>
            </div>



            <div className="col-lg-3 col-md-6">
              {/* Small Article here */}
              <SmallArticle_Ar />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}



